import { useState, type ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

interface QueryProviderProps {
  children: ReactNode;
}

/**
 * `staleTime` curto por padrão: R6 (150 usuários) não pede cache agressivo,
 * e visibilidade errada por cache velho é pior aqui do que uma consulta a
 * mais (regra 10 — invalidação após transição depende disso ser previsível).
 */
export function QueryProvider({ children }: QueryProviderProps) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: 1,
          },
        },
      }),
  );

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
